export default __webpack_public_path__ + "static/media/loading-picture.335e5a73.png";